import * as types from './types';
import { createCoverageReducers } from '../../../common/coverage/reducers';
import { VdcDeviceCoverageRecord } from '../../../../records';

const { initialState, reducer } = createCoverageReducers({
  types,
  CoverageRecord: VdcDeviceCoverageRecord,
});

export default reducer;
export { initialState };
